import { FC, PropsWithChildren } from 'react';
import { Link, UIMatch } from 'react-router';

import { BreadcrumbLink } from '@nablax/shared/ui';

export type CrumbRender = FC<{ match: UIMatch }>;

export const CrumbLink = ({
  match,
  children,
}: PropsWithChildren<{ match: UIMatch }>) => {
  return (
    <BreadcrumbLink asChild>
      <Link to={match.pathname}>{children}</Link>
    </BreadcrumbLink>
  );
};
